import { SignIn } from "./components/sign-in/index.ts";
import { Workspace } from "./components/workspace/index.ts";
import type { Auth } from "./integrations/auth.ts";
import type { PublicConfig } from "./integrations/config.ts";

export function App({ auth, config }: { auth: Auth; config: PublicConfig }) {
  if (!auth.account) return <SignIn onSignIn={() => void auth.signIn()} />;
  return <Workspace auth={auth} config={config} />;
}
